export enum PlayerRole {
  dealer = "You are a Dealer",
  smallBlind = "You are a Small Blind",
  bigBlind = "You are a Big Blind",
  player = "You are a Player",
}

export enum Deck {
  mainDeck = "card back black",
  hiddenPokerCards = "card back orange",
}
